<template>
  <div class="account-detail-container">
    <el-page-header @back="goBack" content="账号详情"></el-page-header>

    <div v-loading="loading" class="detail-content">
      <!-- 第1部分：基本信息 -->
      <el-card class="section-card">
        <template #header>
          <div class="card-header">
            <span>基本信息</span>
            <img v-if="accountResource.headImg" :src="accountResource.headImg"
                 style="width: 50px; height: 50px; border-radius: 4px;"/>
            <span v-else>无头像</span>
          </div>
        </template>
        <el-form label-width="120px">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="角色名">
                <el-input v-model="accountResource.accountName" placeholder="角色名" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="角色ID">
                <el-input v-model="form.roleId" placeholder="角色ID" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="俱乐部">
                <el-input v-model="accountResource.clubName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="俱乐部职务">
                <el-input v-model="clubDutyText" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上阵红淬">
                <el-input v-model="accountResource.redQuench" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="总红淬">
                <el-input v-model="accountResource.redQuenchTotal" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="战力">
                <el-input v-model="powerText" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="功法等级">
                <el-input v-model="legacyLevelText" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="塔层数">
                <el-input v-model="accountResource.towerLevel" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="图鉴等级">
                <el-input v-model="accountResource.pictorial" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="信息同步时间">
                <el-input v-model="accountResource.syncTime" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 资源展示 -->
          <el-collapse v-model="resourceCollapse">
            <el-collapse-item name="resources" title="资源详情">
              <el-row :gutter="20" style="margin-bottom: 10px;">
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">招募令</div>
                    <div class="resource-value">{{ accountResource.recruit || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">木宝箱</div>
                    <div class="resource-value">{{ accountResource.woodBox || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">青铜宝箱</div>
                    <div class="resource-value">{{ accountResource.bronzeBox || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">黄金宝箱</div>
                    <div class="resource-value">{{ accountResource.goldBox || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">铂金宝箱</div>
                    <div class="resource-value">{{ accountResource.platinumBox || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">钻石宝箱</div>
                    <div class="resource-value">{{ accountResource.diamondBox || 0 }}</div>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 10px;">
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">宝箱积分</div>
                    <div class="resource-value">{{ accountResource.box || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">鱼竿</div>
                    <div class="resource-value">{{ accountResource.fishGod || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">金砖</div>
                    <div class="resource-value">{{ accountResource.gold || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">普通鱼竿</div>
                    <div class="resource-value">{{ accountResource.normalFishGod || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">珍珠</div>
                    <div class="resource-value">{{ accountResource.pearl || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">咸鱼币</div>
                    <div class="resource-value">{{ accountResource.coin || 0 }}</div>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 10px;">
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">未领取宝箱积分</div>
                    <div class="resource-value">{{ accountResource.boxPoint || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">四圣蓝玉</div>
                    <div class="resource-value">{{ accountResource.sishengBlue || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">四圣红玉</div>
                    <div class="resource-value">{{ accountResource.sishengRed || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">四圣碎片</div>
                    <div class="resource-value">{{ accountResource.sishengCard || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">四圣宝珠</div>
                    <div class="resource-value">{{ accountResource.sishengBall || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">白玉</div>
                    <div class="resource-value">{{ accountResource.baiyu || 0 }}</div>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 10px;">
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">彩玉</div>
                    <div class="resource-value">{{ accountResource.caiyu || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">贝壳</div>
                    <div class="resource-value">{{ accountResource.shell || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">鱼珠</div>
                    <div class="resource-value">{{ accountResource.shellBall || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">复活丹</div>
                    <div class="resource-value">{{ accountResource.resurrection || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">盐锭</div>
                    <div class="resource-value">{{ accountResource.saltMoney || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">金盐锭</div>
                    <div class="resource-value">{{ accountResource.goldSaltMoney || 0 }}</div>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 10px;">
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">助威币</div>
                    <div class="resource-value">{{ accountResource.helpMoney || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">功法残券</div>
                    <div class="resource-value">{{ accountResource.legacy || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">曜晶徽记</div>
                    <div class="resource-value">{{ accountResource.goldSkinCoin || 0 }}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">皮肤币</div>
                    <div class="resource-value">{{ accountResource.skinCoin || 0 }}</div>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 10px;">
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">周卡剩余</div>
                    <div class="resource-value">{{ accountResource.weekLeft || 0 }}天</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">月卡剩余</div>
                    <div class="resource-value">{{ accountResource.monthLeft || 0 }}天</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="resource-item">
                    <div class="resource-label">赛车通行证</div>
                    <div class="resource-value">{{ accountResource.carLeft || 0 }}天</div>
                  </div>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </el-card>

      <!-- 第2部分：自动化脚本 -->
      <el-card class="section-card">
        <template #header>
          <div class="card-header">
            <span>自动化脚本配置</span>
          </div>
        </template>

        <!-- 2.0 总开关和默认阵容 -->
        <el-form label-width="150px">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="总开关">
                <el-switch
                    v-model="form.loginStatus"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="开启"
                    inactive-text="关闭">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="默认阵容">
                <el-select v-model="form.defaultTeam" placeholder="请选择默认阵容" clearable>
                  <el-option v-for="i in 6" :key="i" :label="`阵容${i}`" :value="i"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 2.1 收菜设置 -->
        <el-collapse v-model="activeCollapse">
          <el-collapse-item name="claimReward" title="收菜设置">
            <el-form label-width="150px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="收菜开关">
                    <el-switch
                        v-model="form.claimRewardStatus"
                        active-text="开"
                        inactive-text="关">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="最大挂机时长">
                    <el-input v-model="hangTimeDisplay" placeholder="小时:分钟" disabled>
                      <template #append>{{ parseHangTime(form.hangTime) }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="好友助力人数">
                    <el-input-number v-model="form.friend" :min="0" :max="10"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="已挂机时长">
                    <el-input v-model="hangedTimeDisplay" placeholder="小时:分钟" disabled>
                      <template #append>{{ parseHangTime(form.hangedTime) }}</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="下次收菜时间">
                    <el-input v-model="form.nextLoginTime" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>

          <!-- 2.2 日常设置 -->
          <el-collapse-item name="dailyTask" title="日常设置">
            <el-form label-width="150px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="日常开关">
                    <el-select v-model="form.dailyTaskStatus" placeholder="请选择日常开关" clearable>
                      <el-option label="开" :value="1"></el-option>
                      <el-option label="关" :value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="付费招募">
                    <el-switch
                        v-model="form.recruitNotFree"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="收罐子">
                    <el-switch
                        v-model="form.claimBottle"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="开宝箱">
                    <el-switch
                        v-model="form.openBox"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="深海灯神">
                    <el-switch
                        v-model="form.genieDeepSea"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="俱乐部BOSS次数">
                    <el-input-number v-model="form.legionBossCnt" :min="0" :max="10"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="俱乐部BOSS阵容">
                    <el-select v-model="form.legionBossTeam" placeholder="请选择阵容" clearable>
                      <el-option v-for="i in 6" :key="i" :label="`阵容${i}`" :value="i"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="魏国灯神">
                    <el-switch
                        v-model="form.genieWei"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="蜀国灯神">
                    <el-switch
                        v-model="form.genieShu"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="吴国灯神">
                    <el-switch
                        v-model="form.genieWu"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="群雄灯神">
                    <el-switch
                        v-model="form.genieQun"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>

          <!-- 2.3 竞技场设置 -->
          <el-collapse-item name="arena" title="竞技场设置">
            <el-form label-width="150px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="竞技场开关">
                    <el-switch
                        v-model="form.arenaStatus"
                        active-text="开"
                        inactive-text="关">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="竞技场阵容">
                    <el-select v-model="form.arenaTeam" placeholder="请选择阵容" clearable>
                      <el-option v-for="i in 6" :key="i" :label="`阵容${i}`" :value="i"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="月度任务">
                    <el-switch
                        v-model="form.arenaMonthStatus"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="竞技场目标">
                    <el-select v-model="form.arenaTarget" placeholder="请选择目标" clearable>
                      <el-option label="战力最高" :value="1"></el-option>
                      <el-option label="战力最低" :value="2"></el-option>
                      <el-option label="积分最高" :value="3"></el-option>
                      <el-option label="积分最低" :value="4"></el-option>
                      <el-option label="随机" :value="5"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>

          <!-- 2.4 盐场设置 -->
          <el-collapse-item name="saltWar" title="盐场设置">
            <el-form label-width="150px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="同步战报">
                    <el-switch
                        v-model="form.syncSaltWar"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>

          <!-- 2.5 梦境设置 -->
          <el-collapse-item name="dungeon" title="梦境设置">
            <el-form label-width="150px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="梦境开关">
                    <el-switch
                        v-model="form.dungeon"
                        active-text="开"
                        inactive-text="关">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider>梦境购买配置</el-divider>
              <div v-if="dungeonSettingParsed">
                <div v-for="(section, sectionKey) in dungeonSectionGroups" :key="sectionKey">
                  <h4>{{
                      sectionKey === 'junior' ? '初级商人' : sectionKey === 'intermediate' ? '中级商人' : '高级商人'
                    }}</h4>
                  <el-row :gutter="20" style="margin-bottom: 10px;">
                    <el-col v-for="(item, key) in section" :key="key" :span="8">
                      <el-form-item :label="item.name">
                        <el-switch
                            v-model="dungeonSettingParsed[key]"
                            active-text="买"
                            inactive-text="不买">
                        </el-switch>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-form>
          </el-collapse-item>

          <!-- 2.6 每日黑市设置 -->
          <el-collapse-item name="blackMarketDay" title="每日黑市设置">
            <el-form label-width="150px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="黑市开关">
                    <el-switch
                        v-model="blackMarketDaySetting.isOpen"
                        active-text="开"
                        inactive-text="关">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="购买方式">
                    <el-select v-model="blackMarketDaySetting.buyType" placeholder="请选择购买方式" clearable>
                      <el-option label="小号单件采购" :value="0"></el-option>
                      <el-option label="大号一键采购" :value="1"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="刷新次数">
                    <el-input-number v-model="blackMarketDaySetting.refresh" :min="0" :max="10"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider>商品购买设置</el-divider>
              <div v-if="blackMarketDaySetting.goods && blackMarketDaySetting.goods.length > 0">
                <el-row :gutter="20" style="margin-bottom: 10px;" v-for="goods in blackMarketDaySetting.goods"
                        :key="goods.goodsId">
                  <el-col :span="6">{{ goods.goodsName }}</el-col>
                  <el-col :span="4">默认价格: {{ goods.defaultCost }}</el-col>
                  <el-col :span="4">预设折扣: {{ goods.defaultDiscount }}折</el-col>
                  <el-col :span="6">
                    <el-form-item label="期望折扣" label-width="80px">
                      <el-input-number v-model="goods.discount" :min="0" :max="10" placeholder="0-10"></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </el-collapse-item>

          <!-- 2.7 黑市周活动设置 -->
          <el-collapse-item name="blackMarketActivity" title="黑市周活动设置">
            <el-form label-width="150px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="周五领奖开关">
                    <el-switch
                        v-model="form.blackActivityStatus"
                        active-text="开"
                        inactive-text="关">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider>周采购设置</el-divider>
              <div v-if="blackMarketActivityParsed && blackMarketActivityParsed.length > 0">
                <el-row :gutter="20" style="margin-bottom: 10px;" v-for="item in blackMarketActivityParsed"
                        :key="item.goodsId">
                  <el-col :span="8">{{ item.goodsName }}</el-col>
                  <el-col :span="8">价格: {{ item.cost }}</el-col>
                  <el-col :span="8">
                    <el-form-item label="是否购买" label-width="80px">
                      <el-switch
                          v-model="item.buyCnt"
                          :active-value="1"
                          :inactive-value="0"
                          active-text="是"
                          inactive-text="否">
                      </el-switch>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </el-collapse-item>

          <!-- 2.8 军团商店设置 -->
          <el-collapse-item name="clubShop" title="军团商店设置">
            <el-form label-width="150px">
              <el-divider>商品购买配置</el-divider>
              <div v-if="clubShopOrderParsed">
                <div v-for="(shopType, shopTypeName) in clubShopGroups" :key="shopTypeName">
                  <h4>{{
                      shopTypeName === 'normalShop' ? '普通商店' : shopTypeName === 'goldShop' ? '金盐锭商店' : '助威币商店'
                    }}</h4>
                  <el-row :gutter="20" style="margin-bottom: 10px;">
                    <el-col v-for="(item, key) in shopType" :key="key" :span="8">
                      <el-form-item :label="item.name">
                        <el-input-number
                            v-model="clubShopOrderParsed[key].cnt"
                            :min="0"
                            :max="item.maxCnt"
                            placeholder="次数"
                            style="width: 100px;">
                        </el-input-number>
                        <el-input-number
                            v-model="clubShopOrderParsed[key].sort"
                            :min="0"
                            placeholder="优先级"
                            style="width: 100px; margin-left: 10px;">
                        </el-input-number>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-form>
          </el-collapse-item>

          <!-- 2.9 功法挂机设置 -->
          <el-collapse-item name="legacy" title="功法挂机设置">
            <el-form label-width="150px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="功法挂机开关">
                    <el-switch
                        v-model="legacySetting.legacyClaim.value"
                        active-text="开"
                        inactive-text="关">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="开启通行证">
                    <el-switch
                        v-model="legacySetting.isVip.value"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="下次收取时间">
                    <el-input v-model="nextLegacyTimeDisplay" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>

          <!-- 2.10 咸将塔设置 -->
          <el-collapse-item name="tower" title="咸将塔设置">
            <el-form label-width="150px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="咸将塔开关">
                    <el-switch
                        v-model="form.towerStatus"
                        active-text="开"
                        inactive-text="关">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="咸将塔阵容">
                    <el-select v-model="form.towerTeam" placeholder="请选择阵容" clearable>
                      <el-option v-for="i in 6" :key="i" :label="`阵容${i}`" :value="i"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="保留小鱼干">
                    <el-input-number v-model="form.towerFishLeave" :min="0"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="下次上号时间">
                    <el-input v-model="form.nextTowerTime" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>

          <!-- 2.11 怪异塔设置 -->
          <el-collapse-item name="evotower" title="怪异塔设置">
            <el-form label-width="150px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="怪异塔开关">
                    <el-switch
                        v-model="form.evotowerStatus"
                        active-text="开"
                        inactive-text="关">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="怪异塔阵容">
                    <el-select v-model="form.evotowerTeam" placeholder="请选择阵容" clearable>
                      <el-option v-for="i in 6" :key="i" :label="`阵容${i}`" :value="i"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="自动合成">
                    <el-switch
                        v-model="form.evotowerHcStatus"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="下次上号时间">
                    <el-input v-model="form.nextEvotowerTime" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>

          <!-- 2.12 赛车设置 -->
          <el-collapse-item name="car" title="赛车设置">
            <el-form label-width="150px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="赛车开关">
                    <el-switch
                        v-model="form.carClaim"
                        active-text="开"
                        inactive-text="关">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="下次收车时间">
                    <el-input v-model="form.nextCarClaimTime" disabled></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="下次发车时间">
                    <el-input v-model="nextSendCarDisplay" disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="自动发车">
                    <el-switch
                        v-model="carSetting.send"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="自动收车">
                    <el-switch
                        v-model="carSetting.claim"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="自动刷车">
                    <el-switch
                        v-model="carSetting.refresh"
                        active-text="是"
                        inactive-text="否">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="今日发车次数">
                    <el-input-number v-model="carSetting.sendCnt" :min="0" disabled></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="护送人繁忙">
                    <el-select v-model="carSetting.helperBusy" placeholder="请选择处理方式" clearable>
                      <el-option label="随机" :value="1"></el-option>
                      <el-option label="等待" :value="2"></el-option>
                      <el-option label="不发车" :value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="等待时间(分钟)">
                    <el-input-number v-model="carSetting.waitMinutes" :min="0" :max="60"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider>大奖设置</el-divider>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="刷新票张数">
                    <el-input-number v-model="carSetting.targetTicket" :min="0"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="招募个数">
                    <el-input-number v-model="carSetting.targetRecruit" :min="0"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="彩玉个数">
                    <el-input-number v-model="carSetting.targetColorJade" :min="0"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="白玉个数">
                    <el-input-number v-model="carSetting.targetWhiteJade" :min="0"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="万能红碎片">
                    <el-input-number v-model="carSetting.targetRedUniversal" :min="0"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="金砖">
                    <el-input-number v-model="carSetting.targetGold" :min="0"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-divider>护送人设置</el-divider>
              <el-row :gutter="20">
                <el-col :span="6" v-for="(helper, index) in carSetting.helper" :key="index">
                  <el-form-item :label="`护送人${index + 1}`">
                    <el-input v-model="carSetting.helper[index]" placeholder="角色ID"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>

          <!-- 2.13 限时活动设置 -->
          <el-collapse-item name="dynamic" title="限时活动设置">
            <el-form label-width="150px">
              <div v-if="dynamicSettingParsed">
                <div v-for="(field, key) in dynamicSettingParsed" :key="key">
                  <el-divider v-if="key !== Object.keys(dynamicSettingParsed)[0]"></el-divider>
                  <h4>{{ field.label }}</h4>
                  <p style="color: #666; margin-bottom: 10px;">{{ field.desc }}</p>
                  <el-row :gutter="20">
                    <el-col :span="8">
                      <el-form-item label="值">
                        <el-input v-model="field.value" :disabled="field.disabled"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </el-card>

      <!-- 第3部分：保存按钮 -->
      <div class="action-buttons">
        <el-button type="primary" @click="save" :loading="saving">保存</el-button>
        <el-button @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'AccountInfoWsDetail',
  data() {
    return {
      loading: false,
      saving: false,
      resourceCollapse: [], // 资源折叠面板
      activeCollapse: [], // 默认展开的折叠面板
      // 账号资源信息
      accountResource: {
        id: '',
        roleId: '',
        accountName:'',
        clubName: '',
        clubDuty: 999,
        redQuench: 0,
        redQuenchTotal: 0,
        power: 0,
        headImg: '',
        syncTime: '',
        legacyLevel: 0,
        recruit: 0,
        woodBox: 0,
        bronzeBox: 0,
        goldBox: 0,
        platinumBox: 0,
        diamondBox: 0,
        box: 0,
        fishGod: 0,
        gold: 0,
        towerLevel: 0,
        pictorial: 0,
        pearl: 0,
        coin: 0,
        boxPoint: 0,
        sishengBlue: 0,
        sishengRed: 0,
        sishengCard: 0,
        sishengBall: 0,
        baiyu: 0,
        caiyu: 0,
        shell: 0,
        shellBall: 0,
        resurrection: 0,
        saltMoney: 0,
        goldSaltMoney: 0,
        helpMoney: 0,
        legacy: 0,
        goldSkinCoin: 0,
        skinCoin: 0,
        normalFishGod: 0,
        weekLeft: 0,
        monthLeft: 0,
        carLeft: 0
      },
      // 功法字典
      legacyDict: [],
      form: {
        id: '',
        roleId: '',
        parentRoleId: '',
        loginStatus: 1,
        claimRewardStatus: true,
        activityStatus: true,
        hangTime: 0,
        friend: 0,
        hangedTime: 0,
        nextLoginTime: '',
        nextCarClaimTime: '',
        dailyTaskStatus: 1,
        recruitNotFree: true,
        claimBottle: true,
        genieDeepSea: true,
        genieWei: true,
        genieShu: true,
        genieWu: true,
        genieQun: true,
        openBox: true,
        legionBossCnt: 0,
        legionBossTeam: 0,
        defaultTeam: 0,
        arenaTeam: 0,
        arenaStatus: true,
        arenaMonthStatus: true,
        arenaTarget: 1,
        dungeon: true,
        dungeonSetting: '',
        legacySetting: '',
        blackMarketDay: '',
        blackActivityStatus: true,
        blackMarketActivity: '',
        carClaim: true,
        carSetting: '',
        towerTeam: 0,
        towerStatus: false,
        towerFishLeave: 0,
        nextTowerTime: '',
        evotowerTeam: 0,
        evotowerStatus: true,
        evotowerHcStatus: true,
        nextEvotowerTime: '',
        dailyTaskTime: '',
        evotowerTask: '',
        dynamicSetting: '',
        clubShopOrder: '',
        miaoCode: '',
        syncSaltWar: true,
        claimReward: false,
        friendOrNot: false
      },
      // 梦境配置字典
      dungeonConfig: {
        "1_0": {"name": "进阶石*200", "cost": "200金砖", "section": "junior"},
        "1_1": {"name": "精铁*300", "cost": "180金砖", "section": "junior"},
        "1_2": {"name": "木质宝箱*10", "cost": "100金砖", "section": "junior"},
        "1_3": {"name": "青铜宝箱*1", "cost": "90金砖", "section": "junior"},
        "1_4": {"name": "普通鱼竿*1", "cost": "80金砖", "section": "junior"},
        "1_5": {"name": "咸神门票*3", "cost": "100万金币", "section": "junior"},
        "1_6": {"name": "咸神火把*1", "cost": "100万金币", "section": "junior"},
        "2_0": {"name": "梦魇石*200", "cost": "600金砖", "section": "intermediate"},
        "2_1": {"name": "进阶石*1000", "cost": "1200金砖", "section": "intermediate"},
        "2_2": {"name": "精铁*1500", "cost": "1000金砖", "section": "intermediate"},
        "2_3": {"name": "黄金宝箱*5", "cost": "1500金砖", "section": "intermediate"},
        "2_4": {"name": "黄金鱼竿*5", "cost": "2000金砖", "section": "intermediate"},
        "2_5": {"name": "招募*5", "cost": "1200金砖", "section": "intermediate"},
        "2_6": {"name": "随机橙*5", "cost": "500万金币", "section": "intermediate"},
        "2_7": {"name": "随机紫*5", "cost": "500万金币", "section": "intermediate"},
        "3_0": {"name": "梦魇石*500", "cost": "1000金砖", "section": "senior"},
        "3_1": {"name": "铂金宝箱*5", "cost": "2000金砖", "section": "senior"},
        "3_2": {"name": "黄金鱼竿*10", "cost": "3000金砖", "section": "senior"},
        "3_3": {"name": "招募令*10", "cost": "2200金砖", "section": "senior"},
        "3_4": {"name": "随机红*5", "cost": "5000金砖", "section": "senior"},
        "3_5": {"name": "随机橙*10", "cost": "1000万金币", "section": "senior"},
        "3_6": {"name": "随机红*10", "cost": "2500万金币", "section": "senior"},
        "3_7": {"name": "普通鱼竿*10", "cost": "5000万金币", "section": "senior"}
      },
      // 军团商店配置字典
      clubShopConfig: {
        "1": {"name": "皮肤币*1", "cost": "2盐锭", "maxCnt": 5, "shopType": "normalShop"},
        "2": {"name": "军团币*5000", "cost": "100盐锭", "maxCnt": 1, "shopType": "normalShop"},
        "3": {"name": "进阶石*8000", "cost": "100盐锭", "maxCnt": 1, "shopType": "normalShop"},
        "4": {"name": "精铁*20000", "cost": "100盐锭", "maxCnt": 1, "shopType": "normalShop"},
        "5": {"name": "白玉*10000", "cost": "100盐锭", "maxCnt": 1, "shopType": "normalShop"},
        "6": {"name": "四圣碎片*1", "cost": "40盐锭", "maxCnt": 1, "shopType": "normalShop"},
        "101": {"name": "灵贝*10", "cost": "100金盐锭", "maxCnt": 1, "shopType": "goldShop"},
        "102": {"name": "珍珠*30", "cost": "100金盐锭", "maxCnt": 1, "shopType": "goldShop"},
        "103": {"name": "白玉*30000", "cost": "100金盐锭", "maxCnt": 1, "shopType": "goldShop"},
        "104": {"name": "军团币*20000", "cost": "100金盐锭", "maxCnt": 1, "shopType": "goldShop"},
        "7": {"name": "随机红*100", "cost": "20助威币", "maxCnt": 1, "shopType": "cheerShop"},
        "8": {"name": "白玉*2000", "cost": "20助威币", "maxCnt": 1, "shopType": "cheerShop"},
        "9": {"name": "军团币*1000", "cost": "20助威币", "maxCnt": 1, "shopType": "cheerShop"},
        "10": {"name": "进阶石*1600", "cost": "20助威币", "maxCnt": 20, "shopType": "cheerShop"},
        "11": {"name": "精铁*4000", "cost": "20助威币", "maxCnt": 20, "shopType": "cheerShop"}
      }
    }
  },
  computed: {
    // 计算俱乐部职务文字
    clubDutyText() {
      const dutyMap = {
        999: '成员',
        1: '团长',
        2: '副团长'
      }
      return dutyMap[this.accountResource.clubDuty] || '未知'
    },

    // 计算战力显示文本
    powerText() {
      const power = this.accountResource.power || 0
      if (power >= 100000000) {
        return (power / 100000000).toFixed(2) + '亿'
      } else if (power >= 10000) {
        return (power / 10000).toFixed(2) + '万'
      }
      return power.toString()
    },

    // 计算功法等级显示文本
    legacyLevelText() {
      const level = this.accountResource.legacyLevel || 0
      const legacy = this.legacyDict.find(item => item.legacyColor === level)
      return legacy ? `${legacy.name} (Lv${level})` : `未知 (Lv${level})`
    },
    // 转换挂机时长显示
    hangTimeDisplay() {
      return this.parseHangTime(this.form.hangTime)
    },
    hangedTimeDisplay() {
      return this.parseHangTime(this.form.hangedTime)
    },
    // 解析carSetting
    carSetting() {
      try {
        if (this.form.carSetting) {
          return JSON.parse(this.form.carSetting)
        }
      } catch (error) {
        console.error('解析carSetting失败:', error)
      }
      return {
        send: true,
        claim: true,
        helper: [0, 0, 0, 0, 0],
        refresh: true,
        sendCnt: 0,
        carClaim: true,
        helperBusy: 2,
        targetGold: 2000,
        nextSendCar: 0,
        waitMinutes: 20,
        targetTicket: 6,
        targetRecruit: 10,
        targetColorJade: 5,
        targetWhiteJade: 2000,
        targetRedUniversal: 999
      }
    },
    // 解析dungeonSetting
    dungeonSettingParsed() {
      try {
        if (this.form.dungeonSetting) {
          return JSON.parse(this.form.dungeonSetting)
        }
      } catch (error) {
        console.error('解析dungeonSetting失败:', error)
      }
      return null
    },
    // 按商人等级分组梦境设置
    dungeonSectionGroups() {
      if (!this.dungeonSettingParsed) return {}

      const groups = {
        junior: {},
        intermediate: {},
        senior: {}
      }

      Object.keys(this.dungeonConfig).forEach(key => {
        const section = this.dungeonConfig[key].section
        if (groups[section]) {
          groups[section][key] = this.dungeonConfig[key]
        }
      })

      return groups
    },
    // 解析legacySetting
    legacySetting() {
      try {
        if (this.form.legacySetting) {
          return JSON.parse(this.form.legacySetting)
        }
      } catch (error) {
        console.error('解析legacySetting失败:', error)
      }
      return {
        isVip: {value: true},
        legacyClaim: {value: true},
        nextLegacyTime: {value: 0}
      }
    },
    // 解析blackMarketDay
    blackMarketDaySetting() {
      try {
        if (this.form.blackMarketDay) {
          return JSON.parse(this.form.blackMarketDay)
        }
      } catch (error) {
        console.error('解析blackMarketDay失败:', error)
      }
      return {
        goods: [],
        isOpen: true,
        buyType: 1,
        refresh: 1
      }
    },
    // 解析blackMarketActivity
    blackMarketActivityParsed() {
      try {
        if (this.form.blackMarketActivity) {
          return JSON.parse(this.form.blackMarketActivity)
        }
      } catch (error) {
        console.error('解析blackMarketActivity失败:', error)
      }
      return []
    },
// 修改 clubShopOrderParsed 计算属性
    clubShopOrderParsed() {
      try {
        if (this.form.clubShopOrder) {
          const parsed = JSON.parse(this.form.clubShopOrder)
          // 确保所有商品都有安全的值
          const safeValues = {}
          Object.keys(this.clubShopConfig).forEach(key => {
            safeValues[key] = {
              cnt: (parsed[key] && parsed[key].cnt) || 0,
              sort: (parsed[key] && parsed[key].sort) || 0
            }
          })
          return safeValues
        }
      } catch (error) {
        console.error('解析clubShopOrder失败:', error)
      }

      // 返回默认值
      const defaultValues = {}
      Object.keys(this.clubShopConfig).forEach(key => {
        defaultValues[key] = {cnt: 0, sort: 0}
      })
      return defaultValues
    },
    // 按商店类型分组军团商店
    clubShopGroups() {
      const groups = {
        normalShop: {},
        goldShop: {},
        cheerShop: {}
      }

      Object.keys(this.clubShopConfig).forEach(key => {
        const shopType = this.clubShopConfig[key].shopType
        if (groups[shopType]) {
          groups[shopType][key] = this.clubShopConfig[key]
        }
      })

      return groups
    },
    // 解析dynamicSetting
    dynamicSettingParsed() {
      try {
        if (this.form.dynamicSetting) {
          return JSON.parse(this.form.dynamicSetting)
        }
      } catch (error) {
        console.error('解析dynamicSetting失败:', error)
      }
      return null
    },
    // 显示下次发车时间
    nextSendCarDisplay() {
      if (this.carSetting.nextSendCar) {
        const date = new Date(this.carSetting.nextSendCar * 1000)
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }).replace(/\//g, '-')
      }
      return ''
    },
    // 显示功法挂机下次收取时间
    nextLegacyTimeDisplay() {
      if (this.legacySetting.nextLegacyTime && this.legacySetting.nextLegacyTime.value) {
        const date = new Date(this.legacySetting.nextLegacyTime.value)
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }).replace(/\//g, '-')
      }
      return ''
    }
  },
  created() {
    this.loadDetail()
    this.loadLegacyDict()
  },
  methods: {
    // 加载详情数据
    async loadDetail() {
      this.loading = true
      const roleId = this.$route.query.roleId
      if (!roleId) {
        this.$message.error('缺少角色ID')
        this.goBack()
        return
      }

      try {
        // 加载基本信息
        const detailRes = await request.get(`/xyzwws/websocket/accountWs/detail/${roleId}`)
        if (detailRes.code === '0') {
          this.form = detailRes.data
        } else {
          this.$message.error(detailRes.msg || '加载基本信息失败')
        }

        // 加载资源信息
        await this.loadAccountResource(roleId)

        this.loading = false
      } catch (error) {
        this.loading = false
        this.$message.error('网络错误，加载失败')
      }
    },

    // 加载账号资源
    async loadAccountResource(roleId) {
      try {
        const res = await request.get(`/xyzwws/websocket/accountWs/resource/${roleId}`)
        if (res.code === '0') {
          this.accountResource = res.data
        } else {
          this.$message.error(res.msg || '加载资源信息失败')
        }
      } catch (error) {
        console.error('加载资源信息失败:', error)
      }
    },

    // 加载功法字典
    async loadLegacyDict() {
      try {
        const res = await request.get('/legacyDict/legacy')
        if (res.code === '0') {
          this.legacyDict = res.data
        }
      } catch (error) {
        console.error('加载功法字典失败:', error)
      }
    },

    // 查询角色资源
    getAccountResources() {
      this.$message.info('资源查询功能暂未实现')
    },

    // 转换挂机时间
    parseHangTime(seconds) {
      if (!seconds) return '0小时0分钟'
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      return `${hours}小时${minutes}分钟`
    },

    // 保存
    save() {
      this.saving = true

      // 组装数据
      const saveData = {...this.form}

      // 处理JSON字段
      saveData.carSetting = JSON.stringify(this.carSetting)
      saveData.dungeonSetting = JSON.stringify(this.dungeonSettingParsed || {})
      saveData.legacySetting = JSON.stringify(this.legacySetting)
      saveData.blackMarketDay = JSON.stringify(this.blackMarketDaySetting)
      saveData.blackMarketActivity = JSON.stringify(this.blackMarketActivityParsed)
      // 在save方法中，处理clubShopOrder保存
      saveData.clubShopOrder = JSON.stringify(this.clubShopOrderParsed)
      saveData.dynamicSetting = JSON.stringify(this.dynamicSettingParsed)

      request.post('/xyzwws/websocket/accountWs/update', saveData)
          .then(res => {
            this.saving = false
            if (res.code === '0') {
              this.$message.success('保存成功')
            } else {
              this.$message.error(res.msg || '保存失败')
            }
          })
          .catch(error => {
            this.saving = false
            this.$message.error('网络错误，保存失败')
          })
    },

    // 返回上一页
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.account-detail-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.detail-content {
  margin-top: 20px;
}

.section-card {
  margin-bottom: 20px;
}

.card-header {
  font-size: 16px;
  font-weight: bold;
}

.action-buttons {
  text-align: center;
  margin-top: 20px;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 4px;
}

.account-detail-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.detail-content {
  margin-top: 20px;
}

.section-card {
  margin-bottom: 20px;
}

.card-header {
  font-size: 16px;
  font-weight: bold;
}

.action-buttons {
  text-align: center;
  margin-top: 20px;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 4px;
}

/* 暗色模式下的分割线样式 */
:deep(.el-divider) {
  background-color: #434343;
  border-color: #434343;
  margin: 20px 0;
}

:deep(.el-divider--horizontal) {
  display: block;
  height: 1px;
  width: 100%;
  margin: 24px 0;
  border-top: 1px solid #434343;
}

:deep(.el-divider__text) {
  background-color: #1d1d1d;
  color: #a8abb2;
  padding: 0 20px;
  font-weight: 500;
  font-size: 13px;
}

/* 暗色模式下的表单元素 */
:deep(.el-form-item__label) {
  color: #a8abb2;
}

/* 暗色模式下的卡片标题 */
:deep(.el-card__header) {
  border-bottom: 1px solid #434343;
  background-color: #141414;
  color: #e5eaf3;
}

:deep(.el-card) {
  background-color: #1d1d1d;
  border: 1px solid #434343;
  color: #e5eaf3;
}

/* 暗色模式下的折叠面板 */
:deep(.el-collapse) {
  border: 1px solid #434343;
  border-radius: 4px;
}

:deep(.el-collapse-item__header) {
  background-color: #141414;
  color: #e5eaf3;
  border-bottom: 1px solid #434343;
  padding: 0 20px;
  height: 48px;
  line-height: 48px;
  font-weight: 600;
}

:deep(.el-collapse-item__wrap) {
  background-color: #1d1d1d;
  border-bottom: 1px solid #434343;
}

:deep(.el-collapse-item__content) {
  background-color: #1d1d1d;
  color: #e5eaf3;
  padding: 20px;
}

/* 暗色模式下的输入框 */
:deep(.el-input__inner) {
  background-color: #0a0a0a;
  border: 1px solid #434343;
  color: #ffffff;
}

:deep(.el-input__inner::placeholder) {
  color: #666;
}

:deep(.el-textarea__inner) {
  background-color: #0a0a0a;
  border: 1px solid #434343;
  color: #ffffff;
}

/* 暗色模式下的按钮 */
:deep(.el-button) {
  border: 1px solid #434343;
}

/* 暗色模式下的开关 */
:deep(.el-switch__label) {
  color: #a8abb2;
}

:deep(.el-switch__label.is-active) {
  color: #409eff;
}

/* 暗色模式下的页头 */
:deep(.el-page-header) {
  color: #e5eaf3;
}

:deep(.el-page-header__left) {
  color: #409eff;
}

/* 暗色模式下的加载遮罩 */
:deep(.el-loading-mask) {
  background-color: rgba(0, 0, 0, 0.7);
}

/* 暗色模式下的数字输入框 */
:deep(.el-input-number) {
  background-color: #0a0a0a;
}

:deep(.el-input-number__decrease),
:deep(.el-input-number__increase) {
  background-color: #141414;
  border: 1px solid #434343;
  color: #a8abb2;
}

:deep(.el-input-number .el-input__inner) {
  text-align: center;
}

/* 暗色模式下的下拉选择框 */
:deep(.el-select-dropdown) {
  background-color: #1d1d1d;
  border: 1px solid #434343;
}

:deep(.el-select-dropdown__item) {
  color: #e5eaf3;
}

:deep(.el-select-dropdown__item.hover),
:deep(.el-select-dropdown__item:hover) {
  background-color: #262626;
}

:deep(.el-select-dropdown__item.selected) {
  background-color: #0a0a0a;
  color: #409eff;
}

/* 暗色模式下的标题 */
h4 {
  color: #409eff;
  margin: 15px 0 10px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid #434343;
}

p {
  color: #a8abb2;
  margin-bottom: 15px;
}

/* 资源项样式 */
.resource-item {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 8px;
  text-align: center;
  border: 1px solid #e8e8e8;
}

.resource-label {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resource-value {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

/* 暗色模式下的资源项 */
body.dark-theme .resource-item {
  background: #262626;
  border: 1px solid #434343;
}

body.dark-theme .resource-label {
  color: #a8abb2;
}

body.dark-theme .resource-value {
  color: #e5eaf3;
}
</style>
